var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-dark",on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.$t('cta.start_earning'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }